import { useEffect, useState } from 'react'

import { UploadItem } from '../../types'

interface UseUploadStateProps {
  activeUploads: UploadItem[]
  allCompleted: boolean
}

export const useUploadState = ({ activeUploads, allCompleted }: UseUploadStateProps) => {
  const [expanded, setExpanded] = useState(false)
  const [isFadingOut, setIsFadingOut] = useState(false)

  useEffect(() => {
    if (allCompleted && activeUploads.length === 0) {
      const fadeTimer = setTimeout(() => {
        setIsFadingOut(true)
      }, 500)
      return () => clearTimeout(fadeTimer)
    }
    setIsFadingOut(false)
    return undefined
  }, [allCompleted, activeUploads.length])

  useEffect(() => {
    if (activeUploads.length > 0) {
      setExpanded(true)
    }
  }, [activeUploads.length])

  return {
    expanded,
    isFadingOut,
    setExpanded
  }
}
